<template>
  
  <div class="featuresfilter" :class="{ 's_active' : isActive }" ref="featuresfilter" style="display: none;">
    
    <div class="featuresfilter-header">
      <div>
        <strong>Filter configurations by included features</strong>
      </div>
      <div style="display: flex; align-items: center;">
        <div class="featuresfilter-item-qty l_demo">
          <svg class="icon"><use href="#check"></use></svg>
          <span>= in your design</span>
        </div>
        <!-- <div>= in your design</div> -->
      </div>
    </div>
    
    <div class="featuresfilter-items">
      
      <button class="featuresfilter-item l_hide-label" v-for="(feature) in builder.features" :class="{ 's_active' : isSelected(feature.id), 's_available' : availableFeatures(feature.id) }" @click="select(feature.id)">
        <div class="featuresfilter-item-icon">
          <svg class="icon"><use :href="`#${feature.slug}`"></use></svg>
        </div>
        <div class="featuresfilter-item-label" v-html="feature.title"></div>
        <div class="featuresfilter-item-qty" v-if="selectedFeatures(feature.id)">
          <svg class="icon"><use href="#check"></use></svg>
          <span v-html="selectedFeatures(feature.id)"></span>
        </div>
        <!-- <div class="featuresfilter-item-qty"><span v-html="availableFeatures(feature.id)"></span></div> -->
      </button>
      
      <button class="featuresfilter-item l_show-all" :class="{ 's_available' : isActive }" @click="clear()">
        <div class="featuresfilter-item-icon">
          <svg class="icon"><use href="#grid-dots"></use></svg>
        </div>
        <div class="featuresfilter-item-label">Show all</div>
      </button>
    
    </div>
    
  </div>
  
</template>

<script setup>
  
var _ = require('lodash');
const dayjs = require('dayjs')
var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)
  
import { ref, computed, onMounted, onUnmounted } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const interval = ref()

onMounted(() => {
  interval.value = setInterval(function(){ 
    console.log('push history')
    builder.featuresFilterHistoryPush();
  }, 5000);
})

onUnmounted(() => {
  clearInterval(interval.value)
})

const isActive = computed(() => {
  if (builder.featuresFilter.length && builder.currentSection.width) return true;
  return false;
})

function clear() {
  builder.featuresFilter = [];
  if (builder.currentItem.quoteId) {
    builder.featuresFilterHistory.push({
      date: dayjs().format(),
      quoteId: builder.currentItem.quoteId,
      itemId: builder.currentItem.id,
      product: builder.currentItem.product.title,
      productLayout: builder.currentItem.productLayout.title,
      productLayoutSection: builder.currentItem.productLayoutSections[builder.sectionIndex].title,
      width: builder.currentSection.width,
      configs: builder.configOptionsForSection.length,
      featureIds: JSON.parse(JSON.stringify(builder.featuresFilter))
    });
  }
}

function select(id) {
  if (isActive) {
    if (isSelected(id)) {
      builder.featuresFilter.splice(builder.featuresFilter.indexOf(id), 1);
    } else {
      builder.featuresFilter.push(id);
    }
  }
  if (builder.currentItem.quoteId) {
    builder.featuresFilterHistory.push({
      date: dayjs().format(),
      quoteId: builder.currentItem.quoteId,
      itemId: builder.currentItem.id,
      product: builder.currentItem.product.title,
      productLayout: builder.currentItem.productLayout.title,
      productLayoutSection: builder.currentItem.productLayoutSections[builder.sectionIndex].title,
      width: builder.currentSection.width,
      configs: builder.configOptionsForSection.length,
      featureIds: JSON.parse(JSON.stringify(builder.featuresFilter))
    });
  }
}

function isSelected(id) {
  if (builder.featuresFilter.indexOf(id) !== -1) return true;
  return false;
}

function availableFeatures(id) {
  if (!_.isUndefined(builder.featuresAvailable[id])) {
    return builder.featuresAvailable[id];
  }
  return 0;
}

function selectedFeatures(id) {
  return builder.currentSelectedFeatures[id].qty;

  // if (!_.isUndefined(builder.featuresAvailable[id])) {
  //   return builder.featuresAvailable[id];
  // }
  // return 0;
}

</script>